import { QUERY_KEYS } from "@forwardflow/helpers/utils"
import ConversationalAIService from "@forwardflow/services/ConversationalAI"
import useSWR from "swr"

export function useAgentSignedUrl() {
  const response = useSWR(
    [QUERY_KEYS.AGENT_SIGNED_URL], 
    () => ConversationalAIService.getConversationalAISignedUrl(),
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      errorRetryCount: 2,
    }
  )

  return {
    ...response,
    signedUrl: response.data?.data?.signed_url || "", 
    isLoading: response.isLoading || response.isValidating
  }
}